import { styled } from 'styled-components';
import { sizes, theme } from 'theme';
import { ActivityDetailsInput } from './SharedActivityFormComponents';

export type CreateQuestionnaireRequest = {
    title: string;
    description: string;
    durationInMins: number | null;
    questions: QuestionInput[];
    moduleId: string;
};

export type UpdateQuestionnaireRequest = {
    title: string;
    description: string;
    durationInMins: number | null;
    questions: UpdateQuestionFields[];
};

export type UpdateQuestionFields = {
    id?: string | null;
    question: string;
    hint: string;
};

export interface UpdateQuestionnaireInput extends ActivityDetailsInput {
    questions: UpdateQuestionFields[];
}

type QuestionInput = {
    question: string;
    hint: string;
};

export interface QuestionnaireInput extends ActivityDetailsInput {
    questions: QuestionInput[];
}

export const QuestionCard = styled.div`
    width: 100%;
    background-color: ${theme.cardSecondaryBackgroundColour};
    border-radius: ${sizes.spacingSm};
    padding: ${sizes.spacingMd};
`;

export const ButtonContainer = styled.div`
    width: 100%;
`;
